import { Component } from 'react';
import BaseChart from 'legacy/javascripts/components/base_chart.es6';

class AdditionalQuestionMultipleChoice extends Component {
  generateLabels(chart) {
    let labels = chart.data.labels;
    return labels.map(
      function (label, idx) {
        return {
          text: this.truncate(label),
          fillStyle: chart.data.datasets[0].backgroundColor[idx],
        };
      }.bind(this),
    );
  }

  truncate(str) {
    const maxLabelLength = 55;
    if (str.length > maxLabelLength) {
      return `${str.substring(0, maxLabelLength - 3)}...`;
    }
    return str;
  }

  firstLabel(tooltipItems, data) {
    let allData = data.datasets[tooltipItems.datasetIndex].data;
    let tooltipData = allData[tooltipItems.index];
    let total = allData.reduce(function (acc, val) {
      return acc + val;
    }, 0);
    let percent = Math.round((tooltipData / total) * 100);
    return `${percent}%: ${this.breakLabels(tooltipItems, data)[0]}`;
  }

  otherLabels(tooltipItems, data) {
    return this.breakLabels(tooltipItems, data).slice(1);
  }

  breakLabels(tooltipItems, data) {
    const maxTooltipLength = 40;
    let label = data.labels[tooltipItems.index];
    if (label.length <= maxTooltipLength) {
      return [label];
    }
    let words = label.split(' ');
    return this.wordsToArray(words);
  }

  wordsToArray(words) {
    const maxTooltipLength = 40;
    let lines = [];
    let str = '';
    words.forEach(function (word) {
      if (str.length + word.length + 1 <= maxTooltipLength) {
        str += word + ' ';
      } else {
        lines.push(str);
        str = word + ' ';
      }
    });
    lines.push(str);
    return lines;
  }

  render() {
    let options = {
      maintainAspectRatio: false,
      legend: {
        labels: {
          generateLabels: this.generateLabels.bind(this),
        },
      },
      doNotTranslateTooltipValue: true,
      tooltips: {
        mode: 'nearest',
        callbacks: {
          title: function () {
            return '';
          },
          label: this.firstLabel.bind(this),
          afterLabel: this.otherLabels.bind(this),
        },
      },
    };

    const extraParams = this.props.data.survey_question
      ? { survey_question_id: this.props.data.question_id }
      : { additional_question_id: this.props.data.question_id };

    return (
      <BaseChart
        type="pie"
        id="additionalQuestionMultipleChoice"
        labels={this.props.data.labels}
        datasets={this.props.data.datasets}
        options={options}
        labelParam="additional_question_response_multiple_choice.raw"
        chartHandler={this.props.chartHandler}
        extraParams={extraParams}
      />
    );
  }
}

export default AdditionalQuestionMultipleChoice;
